// Loads the Google Maps JS API (places library) once and resolves with
// window.google.maps. Safe to call from multiple components.
let loaderPromise = null;

export const loadGoogleMaps = () => {
  if (window.google?.maps?.places) {
    return Promise.resolve(window.google.maps);
  }
  if (loaderPromise) return loaderPromise;

  loaderPromise = new Promise((resolve, reject) => {
    const callbackName = "__ktdGoogleMapsLoaded";
    window[callbackName] = () => {
      delete window[callbackName];
      resolve(window.google.maps);
    };
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAP_KEY}&libraries=places&v=weekly&callback=${callbackName}`;
    script.async = true;
    script.onerror = (err) => {
      loaderPromise = null;
      reject(err);
    };
    document.head.appendChild(script);
  });
  return loaderPromise;
};
